"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _callSuper2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
require("./zh-cn.js");
var _classiceditor = _interopRequireDefault(require("@ckeditor/ckeditor5-editor-classic/src/classiceditor"));
var _essentials = _interopRequireDefault(require("@ckeditor/ckeditor5-essentials/src/essentials"));
var _autoformat = _interopRequireDefault(require("@ckeditor/ckeditor5-autoformat/src/autoformat"));
var _pastefromoffice = _interopRequireDefault(require("@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice"));
var _paragraph = _interopRequireDefault(require("@ckeditor/ckeditor5-paragraph/src/paragraph"));
var _heading = _interopRequireDefault(require("@ckeditor/ckeditor5-heading/src/heading"));
var _bold = _interopRequireDefault(require("@ckeditor/ckeditor5-basic-styles/src/bold"));
var _italic = _interopRequireDefault(require("@ckeditor/ckeditor5-basic-styles/src/italic"));
var _underline = _interopRequireDefault(require("@ckeditor/ckeditor5-basic-styles/src/underline"));
var _strikethrough = _interopRequireDefault(require("@ckeditor/ckeditor5-basic-styles/src/strikethrough"));
var _link = _interopRequireDefault(require("@ckeditor/ckeditor5-link/src/link"));
var _autolink = _interopRequireDefault(require("@ckeditor/ckeditor5-link/src/autolink"));
var _blockquote = _interopRequireDefault(require("@ckeditor/ckeditor5-block-quote/src/blockquote"));
var _horizontalline = _interopRequireDefault(require("@ckeditor/ckeditor5-horizontal-line/src/horizontalline"));
var _fontsize = _interopRequireDefault(require("@ckeditor/ckeditor5-font/src/fontsize"));
var _fontfamily = _interopRequireDefault(require("@ckeditor/ckeditor5-font/src/fontfamily"));
var _fontcolor = _interopRequireDefault(require("@ckeditor/ckeditor5-font/src/fontcolor"));
var _fontbackgroundcolor = _interopRequireDefault(require("@ckeditor/ckeditor5-font/src/fontbackgroundcolor"));
var _liststyle = _interopRequireDefault(require("@ckeditor/ckeditor5-list/src/liststyle"));
var _alignment = _interopRequireDefault(require("@ckeditor/ckeditor5-alignment/src/alignment"));
var _image = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/image"));
var _imagecaption = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imagecaption"));
var _imagestyle = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imagestyle"));
var _imagetoolbar = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imagetoolbar"));
var _imageupload = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imageupload"));
var _imageresize = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imageresize"));
var _imageinsert = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imageinsert"));
var _linkimage = _interopRequireDefault(require("@ckeditor/ckeditor5-link/src/linkimage"));
var _table = _interopRequireDefault(require("@ckeditor/ckeditor5-table/src/table"));
var _tabletoolbar = _interopRequireDefault(require("@ckeditor/ckeditor5-table/src/tabletoolbar"));
var _indent = _interopRequireDefault(require("@ckeditor/ckeditor5-indent/src/indent"));
var _mediaembed = _interopRequireDefault(require("@ckeditor/ckeditor5-media-embed/src/mediaembed"));
var _texttransformation = _interopRequireDefault(require("@ckeditor/ckeditor5-typing/src/texttransformation"));
var _uploadVideo = _interopRequireDefault(require("./plugin/uploadVideo"));
var _videoResize = _interopRequireDefault(require("./plugin/video/videoResize"));
var _index = _interopRequireDefault(require("./plugin/attachmet/index"));
var _index2 = _interopRequireDefault(require("./plugin/pdf/index"));
/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
// import '@ckeditor/ckeditor5-build-classic/build/translations/zh-cn.js'
// The editor creator to use.
// import Code from '@ckeditor/ckeditor5-basic-styles/src/code'
// import CodeBlock from '@ckeditor/ckeditor5-code-block/src/codeblock'
// import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage'
// 自动文本转换
// import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter'
// import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter'
// 自定义组件
// import VideoToolbar from './plugin/video/videoToolbar'
// import UploadAttachment from './plugin/uploadAttachment'
var ClassicEditor = exports.default = /*#__PURE__*/function (_ClassicEditorBase) {
  function ClassicEditor() {
    (0, _classCallCheck2.default)(this, ClassicEditor);
    return (0, _callSuper2.default)(this, ClassicEditor, arguments);
  }
  (0, _inherits2.default)(ClassicEditor, _ClassicEditorBase);
  return (0, _createClass2.default)(ClassicEditor);
}(_classiceditor.default); // Plugins to include in the build.
ClassicEditor.builtinPlugins = [_essentials.default, _autoformat.default, _pastefromoffice.default, _paragraph.default, _heading.default, _bold.default, _italic.default, _underline.default, _strikethrough.default,
// Code,
// CodeBlock,

_link.default, _autolink.default, _blockquote.default, _horizontalline.default, _fontsize.default, _fontfamily.default, _fontcolor.default, _fontbackgroundcolor.default, _liststyle.default, _alignment.default,
// EasyImage,
_image.default, _imagecaption.default, _imagestyle.default, _imagetoolbar.default, _imageupload.default, _imageresize.default, _imageinsert.default, _linkimage.default, _table.default, _tabletoolbar.default, _indent.default, _mediaembed.default, _videoResize.default,
// VideoToolbar,

_texttransformation.default,
// Base64UploadAdapter,
// SimpleUploadAdapter

_uploadVideo.default, _index.default, _index2.default];

// Editor configuration.
ClassicEditor.defaultConfig = {
  toolbar: {
    items: ['heading', '|', 'bold', 'italic', 'underline', 'strikethrough',
    // 'code',
    // 'codeblock',
    '|',
    // 'link',
    'blockQuote', 'undo', 'redo', 'horizontalLine', '|', 'fontSize', 'fontFamily', 'fontcolor', 'fontbackgroundcolor', '|', 'bulletedList', 'numberedList', 'alignment', '|',
    // 'imageUpload',
    'imageInsert',
    // 'mediaEmbed',
    // 'uploadVideo',
    // 'uploadAttachment',
    'pdf', '|',
    // 'indent',
    // 'outdent'
    'insertTable']
  },
  heading: {
    options: [{
      model: 'paragraph',
      title: 'Paragraph',
      class: 'ck-heading_paragraph'
    }, {
      model: 'heading1',
      view: 'h1',
      title: 'Heading 1',
      class: 'ck-heading_heading1'
    }, {
      model: 'heading2',
      view: 'h2',
      title: 'Heading 2',
      class: 'ck-heading_heading2'
    }, {
      model: 'heading3',
      view: 'h3',
      title: 'Heading 3',
      class: 'ck-heading_heading3'
    }]
  },
  fontSize: {
    options: [9, 11, 12, 14, 16, 18, 20, 22, 24, 28, 30, 32, 34, 36, 38]
  },
  alignment: {
    options: ['left', 'center', 'right', 'justify']
  },
  image: {
    toolbar: ['imageTextAlternative', '|', 'imageResize', '|', 'linkImage', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight'],
    types: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff'],
    styles: ['full', 'alignLeft', 'alignRight'],
    resizeUnit: 'px',
    resizeOptions: [{
      name: 'imageResize:original',
      label: 'Original',
      value: null
    }, {
      name: 'imageResize:400',
      label: '400px',
      value: '400'
    }, {
      name: 'imageResize:600',
      label: '600px',
      value: '600'
    }, {
      name: 'imageResize:800',
      label: '800px',
      value: '800'
    }, {
      name: 'imageResize:1000',
      label: '1000px',
      value: '1000'
    }, {
      name: 'imageResize:1200',
      label: '1200px',
      value: '1200'
    }]
  },
  link: {
    // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
    addTargetToExternalLinks: true
  },
  mediaEmbed: {
    // toolbar: ['videoResize'],
    resizeUnit: 'px',
    // resizeOptions: [
    //   {
    //     name: 'videoResize:original',
    //     label: 'Original',
    //     value: null
    //   },
    //   {
    //     name: 'videoResize:200',
    //     label: '200px',
    //     value: '200'
    //   },
    //   {
    //     name: 'videoResize:50',
    //     label: '50px',
    //     value: '50'
    //   }
    // ],
    extraProviders: [{
      name: 'myVideo',
      url: [/\.(mp4)/],
      html: function html(match) {
        var src = match.input;
        return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;pointer-events: auto;">' + '<video controls style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" src="' + src + '">' + '</video>' + '</div>';
      }
    }]
  },
  table: {
    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'
    // 'tableCellProperties',
    // 'tableProperties'
    ]
  },
  tableProperties: {
    // ...
  },
  tableCellProperties: {
    // ...
  },
  // This value must be kept in sync with the language defined in webpack.config.js.
  language: 'zh-cn',
  placeholder: ''
};